<template>
  <b-row>
    <b-col
      cols="12"
      md="4"
    >
      <b-card
        title="Itens de Pauta"
        sub-title="Adicione itens de pauta e depois opções de voto para cada item"
      >
        <b-card-body>
          <!--/ payment  -->
          <b-button
            v-b-modal.modal-item-pauta
            variant="outline-primary"
            block
            @click="newItemPauta"
          >
            Adicionar Novo Item
          </b-button>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col
      v-for="itemPauta in itensPauta"
      :key="itemPauta.id"
      cols="12"
      md="4"
    >
      <b-card :title="itemPauta.descricao">
        <b-card-body>
          <b-row>
            <b-col>
              <b-button
                variant="outline-primary"
                @click="confirmDeleteItemPauta(itemPauta)"
              >Excluir</b-button>
            </b-col>

            <b-col>
              <b-button
                v-b-modal.modal-item-pauta
                variant="primary"
                @click="onClickEditar(itemPauta)"
              >Editar</b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-modal
      id="modal-item-pauta"
      ok-only
      ok-title="Salvar"
      centered
      size="lg"
      :title="itemPauta.descricao"
    >
      <b-row>
        <b-col>
          <b-form-input
            v-model="itemPauta.descricao"
            placeholder="Descrição"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-checkbox
            v-model="itemPauta.permiteVoto"
            switch
            inline
          >Permite que o item da pauta seja votado.</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <template>
            <quill-editor
              v-model="itemPauta.detalhamento"
              :options="editorOption"
              class="editor"
            />
          </template>
        </b-col>
      </b-row>
      <div class="b-row">
        <div class="b-col w-full sm:w-1/1 mb-6">
          <!-- Opções de voto -->
          <b-card title="Opções de voto">
            <div class="b-row">
              <div class="b-col sm:w-1/1 md:w-1/2">
                <div class="b-row mb-6">
                  <div class="b-col w-full">
                    <b-input
                      v-model="itemVoto.titulo"
                      v-validate="'required|min:3|max:255'"
                      data-vv-validate-on="blur"
                      label="Título"
                      name="título"
                      class="w-full"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      icon-no-border
                    />
                  </div>
                </div>
                <div class="b-row mb-6">
                  <div class="b-col w-full">
                    <form>
                      <b-form-textarea
                        v-model="itemVoto.descricao"
                        label="Descrição"
                        name="Descrição"
                        counter="200"
                        rows="3"
                        maxlength="200"
                        placeholder="Digite a descrição"
                      />
                      <b-button
                        v-if="itemVoto.id <= 0"
                        class="shadow-lg"
                        type="gradient"
                        @click="addOpcaoVoto()"
                      >Add Opção</b-button>
                      <b-button
                        v-if="itemVoto.id > 0"
                        class="shadow-lg"
                        type="gradient"
                        @click="updateOpcaoVoto()"
                      >Atualizar</b-button>
                      <b-button
                        v-if="itemVoto.id > 0"
                        class="shadow-lg ml-3"
                        color="danger"
                        @click="deleteOpcaoVoto()"
                      >Excluir</b-button>
                    </form>
                  </div>
                </div>
              </div>
              <div class="b-col sm:w-1/1 md:w-1/2">
                <div class="b-row">
                  <div class="b-col sm:w-1/1 w-full mb-2">
                    <b-divider
                      v-if="itensVotos && itensVotos.length > 0"
                      color="primary"
                    >Opções Adicionadas</b-divider>
                    <span
                      v-else
                      class
                    >Nenhuma opção adicionada</span>
                  </div>
                </div>
                <div
                  v-for="(voto, index) in itensVotos"
                  :key="'voto-' + index"
                  class="b-col sm:w-1/1 w-full mb-3"
                >
                  <b-card
                    class="mr-2 sm:w-1/1 w-full"
                    style="cursor:pointer"
                    @click="setOpcaoVoto(voto)"
                  >
                    <p class="text-lg font-semibold truncate">
                      {{ voto.titulo }}
                    </p>
                    <span class="text-sm">{{ voto.descricao }}</span>
                  </b-card>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>

      <div class="flex justify-between flex-wrap">
        <b-button
          class="mt-4"
          type="border"
          color="primary"
          @click="modalItemPauta = false"
        >Cancelar</b-button>
        <b-button
          class="mt-4 mr-2 shadow-lg"
          type="gradient"
          color="success"
          icon-pack="feather"
          icon="icon-save"
          gradient-color-secondary="#CE9FFC"
          @click="gravarItemPauta"
        >Gravar</b-button>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import {
  BModal,
  VBModal,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import AssembleiaAPI from '@/api/assembleia'

export default {
  name: 'AssembleiaItemPautaList',
  components: {
    quillEditor,
    BModal,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    assembleia: Object,
  },
  data() {
    return {
      itensPauta: [],
      itemPauta: {
        descricao: null,
        detalhamento: null,
        permiteVoto: true,
      },
      itensVotos: [],
      itemVoto: {
        id: 0,
        titulo: '',
        descricao: '',
      },
      modalItemPauta: false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ['link', 'image', 'video', 'formula'],
            ['clean'], // remove formatting button
          ],
        },
        placeholder:
          'Detalhe aqui o item que será colocado em pauta na sua assembleia.',
      },
      editorOptionOpcaoDeVoto: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ['link', 'image', 'video', 'formula'],
            ['clean'], // remove formatting button
          ],
        },
        placeholder: 'Detalhe aqui o tipo de opção',
      },
    }
  },
  watch: {
    assembleia() {
      if (this.assembleia.id) {
        this.listItemPauta()
      }
    },
  },
  created() {
    if (this.assembleia.id) {
      this.listItemPauta()
    }
  },
  methods: {
    newItemPauta() {
      this.itemPauta = {
        descricao: null,
        detalhamento: null,
        permiteVoto: true,
      }
      this.modalItemPauta = true
    },
    listItemPauta() {
      AssembleiaAPI.listItemPauta(this.assembleia.id).then(res => {
        this.itensPauta = res.data.content
      })
    },
    gravarItemPauta() {
      if (!this.itemPauta.id) {
        this.createItemPauta()
      } else {
        this.patchItemPauta()
      }
    },
    createItemPauta() {
      this.$loading.show()
      AssembleiaAPI.createItemPauta(this.assembleia.id, this.itemPauta)
        .then(res => {
          this.$loading.hide()
          this.itemPauta.id = res.data.id
          this.itensPauta.push(res.data)
          this.$vs.notify({
            title: 'Item da Pauta',
            text: 'Item da Pauta atualizado com sucesso',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position: 'top-center',
          })
          this.modalItemPauta = false
        })
        .catch(error => {
          this.$loading.hide()
          this.$vs.notify({
            title: 'Item da Pauta',
            text: error.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position: 'top-center',
          })
        })
    },
    patchItemPauta() {
      this.$loading.show()
      AssembleiaAPI.patchItemPauta(
        this.assembleia.id,
        this.itemPauta.id,
        this.itemPauta,
      )
        .then(() => {
          this.$loading.hide()
          this.$vs.notify({
            title: 'Item da Pauta',
            text: 'Item da Pauta atualizado com sucesso',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position: 'top-center',
          })
          this.modalItemPauta = false
        })
        .catch(error => {
          this.$loading.hide()
          this.$vs.notify({
            title: 'Item da Pauta',
            text: error.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position: 'top-center',
          })
        })
    },
    onClickEditar(itemPauta) {
      this.modalItemPauta = true
      this.$set(this, 'itemPauta', itemPauta)

      if (itemPauta.id) {
        this.listOpcaoVoto()
      }
    },
    confirmDeleteItemPauta(itemPauta) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: `Você desenha excluir o item "${itemPauta.descricao}" da pauta?`,
        accept: this.deleteItemPauta,
        acceptText: 'Confirmar',
        cancelText: 'Cancelar',
      })
      this.itemPauta = itemPauta
    },
    deleteItemPauta() {
      this.$loading.show()
      AssembleiaAPI.deleteItemPauta(this.assembleia.id, this.itemPauta.id)
        .then(() => {
          this.$loading.hide()
          this.itensPauta = this.itensPauta.filter(
            item => item.id !== this.itemPauta.id,
          )
          this.$vs.notify({
            title: 'Item da Pauta',
            text: 'Item da Pauta excluído com sucesso',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position: 'top-center',
          })
          this.modalItemPauta = false
        })
        .catch(error => {
          this.$loading.hide()
          this.$vs.notify({
            title: 'Item da Pauta',
            text: error.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position: 'top-center',
          })
        })
    },
    listOpcaoVoto() {
      this.itensVotos = []
      AssembleiaAPI.listOptionsVote(this.assembleia.id, this.itemPauta.id).then(
        res => {
          if (res.data && res.data.content) {
            this.itensVotos.push(...res.data.content)
          }
        },
      )
    },
    addOpcaoVoto() {
      this.$loading.show()
      AssembleiaAPI.createOptionVote(
        this.assembleia.id,
        this.itemPauta.id,
        this.itemVoto,
      )
        .then(res => {
          if (res.data.id) {
            this.itensVotos.push(res.data)
          }
          this.clearOpcaoVoto()
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Opções de voto',
            text: 'Não foi possível incluir',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position: 'top-center',
          })
        })
        .finally(() => {
          this.$loading.hide()
        })
    },
    setOpcaoVoto(voto) {
      this.itemVoto = voto
    },
    updateOpcaoVoto() {
      this.$loading.show()
      AssembleiaAPI.updateOptionVote(
        this.assembleia.id,
        this.itemPauta.id,
        this.itemVoto.id,
        this.itemVoto,
      )
        .then(() => {
          this.clearOpcaoVoto()
          this.listOpcaoVoto()
        })
        .finally(() => {
          this.$loading.hide()
        })
    },
    deleteOpcaoVoto() {
      this.$loading.show()
      AssembleiaAPI.deleteOptionVote(
        this.assembleia.id,
        this.itemPauta.id,
        this.itemVoto.id,
      )
        .then(() => {
          this.clearOpcaoVoto()
          this.listOpcaoVoto()
        })
        .finally(() => {
          this.$loading.hide()
        })
    },
    clearOpcaoVoto() {
      this.itemVoto.descricao = ''
      this.itemVoto.titulo = ''
      this.itemVoto.id = 0
    },
  },
}
</script>

<style lang="scss"></style>
